<template>
  <v-dialog :value="showDialog" @input="close()" width="500px">
    <v-card class="image-card">
      <div
        class="icon-layout"
        v-if="imageData.value"
        style="padding: 10px 20px 10px;"
      >
        <v-btn
          class="photo-form-button"
          @click="rotateRight"
          icon
          small
          color="accent"
        >
          <v-icon size="22">rotate_right</v-icon>
        </v-btn>
        <v-btn class="photo-form-button" icon small color="accent">
          <a
            v-if="imageData.value"
            :download="imageData.label"
            :href="imageData.value"
          >
            <v-icon size="20" color="accent">file_download</v-icon>
          </a>
        </v-btn>
      </div>
      <div :style="`transform: rotate(${rotation}deg);`">
        <img
          v-if="imageData.value"
          :src="imageData.value"
          :alt="imageData.label"
          contain
          max-height="550px"
        />
      </div>

      <v-card-title class="download">
        <h4>{{ imageData.label }}</h4>
        <task-decision-buttons
          v-if="taskDecisionButtons"
          @approve="
            $emit('updateTaskContents', {
              decision: 'approve',
              uuid: imageData.uuid
            })
          "
          @reject="
            $emit('updateTaskContents', {
              decision: 'reject',
              uuid: imageData.uuid
            })
          "
          :uuid="imageData.uuid"
          :taskContents="taskContents"
        />
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
import TaskDecisionButtons from "@/components/FieldManagement/FieldWork/Data/TaskDecisionButtons";

export default {
  name: "PhotoView",

  components: {
    TaskDecisionButtons
  },

  props: {
    dialog: {
      type: Boolean,
      required: true
    },

    imageData: {
      required: true
    },

    taskDecisionButtons: {
      type: Boolean,
      default: false
    },

    taskContents: {
      type: Array
    }
  },

  data() {
    return {
      rotation: 0
    };
  },

  computed: {
    showDialog() {
      return this.dialog;
    }
  },

  methods: {
    close() {
      this.$emit("close", false);
    },

    /**
     * adds 90 to rotation variable used in html as a css transform attribute.
     */
    rotateRight() {
      this.rotation += 90;
    }
  }
};
</script>

<style scoped>
.image-card {
  padding: 10px;
}
img {
  max-height: 550px;
}
.image-card >>> .v-image__image .v-image__image--contain {
  image-orientation: from-image;
}
.download {
  display: flex;
  justify-content: space-between;
}
.icon-layout {
  display: flex;
  justify-content: right;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/FieldManagement/FieldWork/Data/TaskType/PhotoView.vue